import getRandomInt from '../functions/getRandomInt';
export default function random(singles) {
    let m = 0, n = getRandomInt(3, 6);
    if (singles === undefined) {
        if (getRandomInt(1, 2) == 1) { // positive single
            ({ n, m } = getPositiveSingles(n, m));
        }
    }
    else if (singles) {
        ({ n, m } = getPositiveSingles(n, m));
    }
    return n * 10 + m;
}
function getPositiveSingles(n, m) {
    if (n == 6) {
        n = getRandomInt(3, 5);
    }
    m = getRandomInt(1, 6 - n);
    return { n, m };
}
